import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import * as removeSelectors from '@store/dashboards/remove/selectors';
import { removePopupVisibleSelector } from '@store/dashboards/ui/selectors';
import * as dashboardsUIActions from '@store/dashboards/ui/actions';
import { updateDefaultLandingPage } from '@store/defaultLandingPage/actions';
import { selector as defaultLandingPageSelector } from '@store/defaultLandingPage';
import * as dashboardRemoveActions from '@store/dashboards/remove/actions';
import RemoveDashboardPopup from './RemoveDashboardPopup';


const selector = createSelector(
  removePopupVisibleSelector,
  removeSelectors.removeLoaderSelector,
  removeSelectors.errorCodeSelector,
  removeSelectors.payloadSelector,
  defaultLandingPageSelector,
  (
    visible,
    isFetching,
    errorCode,
    payload,
    defaultLandingPage,
  ) => ({
    visible,
    isFetching: !!payload && isFetching,
    hasError: errorCode !== 0,
    defaultLandingPage,
  }),
);

export default connect(selector, {
  toggleVisible: dashboardsUIActions.toggleRemovePopupVisible,
  init: dashboardRemoveActions.initRequest,
  removeDashboard: dashboardRemoveActions.removeDashboardById,
  updateDefaultLandingPage,
})(RemoveDashboardPopup);
